var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow-right-guedelon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21.112,
    viewBox: "0 0 20 21.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-guedelon .a{fill:#e87722;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.001 2803.112) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M425.622,486.247l.377-5.979c3.671.252,7.065.291,10.6.263-1.4-1.733-2.842-3.426-4.255-5.147,1.955-.893,3.988-1.707,5.861-2.683a56.5,56.5,0,0,0,3.954,5.931l3.459,4.66s-3.111,4.465-3.177,4.59c-.586.966-1.2,1.964-1.765,2.965a17.432,17.432,0,0,1-1.765,2.965c-1.857-.8-3.668-1.652-5.648-2.33,1.295-1.822,2.681-3.553,3.966-5.384-3.926-.011-7.529.1-11.611.148",
    transform: "translate(-362.621 2309.298)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.46280e94ec58b0f43a1b8d57f65277ee.svg";
export { ForwardRef as ReactComponent };